export default __webpack_public_path__ + "static/media/white-arrow.7fe26236.svg";